// @ts-nocheck
import React from 'react';
import { Tile, Button, Grid, Column, Select, Stack, Tag } from '@carbon/react';
import { Bot } from '@carbon/icons-react';

// Typography components handled differently in Carbon

function TutoringSession() {
  return (
    <div style={{ padding: '0 0 24px', marginLeft: 240 }}>
      <Title level={2} style={{ marginBottom: 24, color: '#1890ff' }}>
        AI Tutoring Session
      </Title>

      <Grid gutter={[16]}>
        <Column xs={24} md={8}>
          <Tile style={{ marginBottom: '16px' }} title="Start New Session">
            <Stack direction="vertical" style={{ width: '100%' }} size="middle">
              <div>
                <span style={{ fontWeight: 'bold' }}>Subject</span>
                <Select style={{ width: '100%', marginTop: 8 }} placeholder="Choose a subject" size="large">
                  <Select.Option value="mathematics">Mathematics</Select.Option>
                  <Select.Option value="science">Science</Select.Option>
                  <Select.Option value="language_arts">Language Arts</Select.Option>
                  <Select.Option value="social_studies">Social Studies</Select.Option>
                </Select>
              </div>

              <div>
                <span style={{ fontWeight: 'bold' }}>Topic (Optional)</span>
                <Select
                  style={{ width: '100%', marginBottom: 8 }}
                  placeholder="Specific topic you need help with"
                  size="large"
                  allowClear
                >
                  <Select.Option value="algebra">Algebra</Select.Option>
                  <Select.Option value="geometry">Geometry</Select.Option>
                  <Select.Option value="fractions">Fractions</Select.Option>
                </Select>
              </div>

              <div>
                <span style={{ fontWeight: 'bold' }}>Difficulty Level</span>
                <Select style={{ width: '100%', marginTop: 8 }} defaultValue="adaptive" size="large">
                  <Select.Option value="supportive">Supportive (Extra Help)</Select.Option>
                  <Select.Option value="adaptive">Adaptive (Just Right)</Select.Option>
                  <Select.Option value="challenging">Challenging (Push Me)</Select.Option>
                </Select>
              </div>

              <Button
                kind="primary"
                size="large"
                icon={<PlayCircleOutlined />}
                block
                style={{ marginTop: 16, height: 48 }}
              >
                Start AI Tutoring
              </Button>
            </Stack>
          </Tile>
        </Column>

        <Column xs={24} md={16}>
          <Tile style={{ marginBottom: '16px' }}>
            <div style={{ textAlign: 'center', padding: '60px 40px' }}>
              {/* Avatar placeholder */}
              <div
                style={{ backgroundColor: '#1890ff', marginBottom: 24, width: 60, height: 60, borderRadius: '50%' }}
              ></div>

              <Title level={3} style={{ color: '#1890ff' }}>
                Meet Sigma, Your AI Tutor! 🤖
              </Title>

              <Paragraph style={{ fontSize: '16px', color: '#595959', maxWidth: 480, margin: '0 auto 24px' }}>
                I'm here to help you learn through questions and discovery. I won't give you direct answers, but I'll
                guide you to find them yourself. That's how real learning happens!
              </Paragraph>

              <Stack size="middle" wrap style={{ marginBottom: 32 }}>
                <Tag color="blue">Socratic Method</Tag>
                <Tag color="green">Safe Learning</Tag>
                <Tag color="orange">Adaptive</Tag>
                <Tag color="purple">24/7 Available</Tag>
              </Stack>

              <div style={{ background: '#f6ffed', padding: 20, borderRadius: 8, border: '1px solid #b7eb8f' }}>
                <span style={{ fontWeight: 'bold', color: '#389e0d' }}>🎯 Learning Tips:</span>
                <ul style={{ textAlign: 'left', marginTop: 8, marginBottom: 0 }}>
                  <li>Ask specific questions about what you're learning</li>
                  <li>Don't ask for direct answers - ask for guidance instead</li>
                  <li>Share your thinking process so I can help you better</li>
                  <li>Take your time - learning happens at your own pace</li>
                </ul>
              </div>
            </div>
          </Tile>
        </Column>
      </Grid>
    </div>
  );
}

export default TutoringSession;
